import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mx-auto text-left p-8 justify-center items-center" }
const _hoisted_2 = { class: "text-3xl mb-2 font-londrina" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row" }
const _hoisted_4 = { class: "max-w-xl" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://opensea.io/collection/named-noun",
      class: "underline font-londrina"
    }, "Named Noun")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://opensea.io/collection/nouns-love",
      class: "underline font-londrina"
    }, "Nouns Love")
  ])
], -1)
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = {
  key: 0,
  class: "flex"
}
const _hoisted_10 = { class: "flex-none w-32" }
const _hoisted_11 = { class: "flex-initial w-64" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "align-right px-8 inline-block px-6 py-2.5 text-black bg-white" }
const _hoisted_19 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_20 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_21 = {
  key: 2,
  class: "font-bold"
}
const _hoisted_22 = { key: 3 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "animate-spin material-icons text-lg text-op-teal mr-2" }, "schedule", -1)
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "text-red-500" }
const _hoisted_29 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-2 w-screen place-content-center items-center" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 0,
  class: "w-32 inline-block px-6 py-2.5 text-gray-500 bg-white leading-tight rounded shadow-md"
}
const _hoisted_32 = {
  key: 1,
  class: "w-32 inline-block px-6 py-2.5 text-gray-500 bg-white leading-tight rounded shadow-md"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("vote.title")) + " " + _toDisplayString(new Intl.DateTimeFormat('ja-JP', { dateStyle: 'short', timeStyle: 'long' }).format(_ctx.vote_event.start)) + " - " + _toDisplayString(new Intl.DateTimeFormat('ja-JP', { dateStyle: 'short', timeStyle: 'long' }).format(_ctx.vote_event.end)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.$t("vote.description")), 1),
        _hoisted_5,
        (!_ctx.isVoted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("vote.how_to_vote")), 1))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_ctx.displayAccount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("message.walletId")), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.displayAccount), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tokenGate == 'switchNetwork')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.nounsCount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.youHaveNouns", { nounsCount: _ctx.nounsCount })), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.pleaseSwitchToPolygon")) + " ", 1),
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchToPolygon && _ctx.switchToPolygon(...args))),
                        class: "underline"
                      }, _toDisplayString(_ctx.$t("menu.switch")), 1)
                    ]))
              ]))
            : (_ctx.tokenGate == 'active')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_ctx.namedNounCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.youHaveNFTs", { namedNounCount: _ctx.namedNounCount })), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("message."+_ctx.tokenGate)), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("message.please_connect")), 1)
                ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (new Date() < _ctx.vote_event.start)
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("vote.before_vote")), 1))
          : (_ctx.vote_event.end < new Date())
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("vote.after_vote")), 1))
            : (_ctx.isVoteReady)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("vote.vote_notice")), 1))
              : (_ctx.isVoting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(_toDisplayString(_ctx.$t("vote.button_voting")), 1)
                  ]))
                : (_ctx.isVoted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("vote.voted_thanks")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      (_ctx.user)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("vote.button_need_token")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("vote.button_need_signin")), 1))
                    ])),
        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.errorMessage), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selections, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.key,
          class: "px-2 py-6"
        }, [
          _createElementVNode("iframe", {
            class: "mb-1",
            src: `https://www.youtube.com/embed/${option.key}`,
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }, "\n        ", 8, _hoisted_30),
          (_ctx.isVoted)
            ? (_openBlock(), _createElementBlock("button", _hoisted_31, _toDisplayString(_ctx.$t("vote.button_voted")), 1))
            : (! _ctx.isVoteReady)
              ? (_openBlock(), _createElementBlock("button", _hoisted_32, _toDisplayString(_ctx.$t("vote.button_selection")), 1))
              : (_ctx.isSelected(option.id))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: ($event: any) => (_ctx.setSelected(option.id)),
                    class: "w-32 inline-block px-6 py-2.5 bg-green-500 text-white leading-tight rounded shadow-md"
                  }, _toDisplayString(_ctx.$t("vote.button_selected")), 9, _hoisted_33))
                : (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: ($event: any) => (_ctx.setSelected(option.id)),
                    class: "w-32 inline-block px-6 py-2.5 bg-white text-green-500 leading-tight rounded shadow-md hover:bg-green-100 hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0"
                  }, _toDisplayString(_ctx.$t("vote.button_selection")), 9, _hoisted_34))
        ]))
      }), 128))
    ])
  ]))
}